var map = {
	"./bigTruck/bigTruck-orange.png": "39a8",
	"./bus/bus-orange.png": "151e",
	"./car/car-orange.png": "c34e",
	"./container/container-orange.png": "2048",
	"./doubleCabin/doubleCabin-orange.png": "8a52",
	"./electricCar/electricCar-orange.png": "0b05",
	"./electricMotorcycle/electricMotorcycle-orange.png": "aad8",
	"./excavator/excavator-orange.png": "d606",
	"./motorcycle/motorcycle-orange.png": "478f",
	"./smallTruck/smallTruck-orange.png": "d4a7",
	"./tractor/tractor-orange.png": "d019",
	"./truckHead/truckHead-orange.png": "0298",
	"./van/van-orange.png": "52d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60440";